// src/components/AdminCatalogEdit.js — extracted from App.js
import React, { useState } from "react";

// ─── Admin inline catalog entry editor ───────────────────────────────────────
export function AdminCatalogEdit({ entry, catalogEntries, saveCatalog, onClose, toast }) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ brand:entry.brand||"", model:entry.model||"", decade:entry.decade||"", condition:entry.condition||"", movement:entry.movement||"", description:entry.description||"", price:entry.price||"", reference:entry.reference||"" });
  const up = (k,v) => setForm(p=>({...p,[k]:v}));

  const save = () => {
    saveCatalog(catalogEntries.map(e => e.id!==entry.id ? e : { ...e, ...form, price:form.price?parseInt(form.price):null }));
    toast("Entry updated.");
    setOpen(false);
    onClose();
  };

  if (!open) return (
    <div style={{borderTop:"1px solid var(--bd)",paddingTop:14,marginTop:4}}>
      <button onClick={()=>setOpen(true)} style={{fontSize:11,fontFamily:"'DM Mono',monospace",padding:"7px 14px",borderRadius:8,border:"1px solid var(--bd)",background:"var(--bg2)",cursor:"pointer",color:"var(--ink3)",letterSpacing:"0.06em"}}>✎ Admin: Edit this entry</button>
    </div>
  );
  return (
    <div style={{borderTop:"1px solid var(--bd)",paddingTop:16,marginTop:4}}>
      <div style={{fontFamily:"'DM Mono',monospace",fontSize:9,color:"var(--ink3)",letterSpacing:"0.1em",marginBottom:12}}>ADMIN — EDIT ENTRY</div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:10}}>
        <div><label style={{fontFamily:"'DM Mono',monospace",fontSize:9,color:"var(--ink3)",display:"block",marginBottom:4}}>BRAND</label><input value={form.brand} onChange={e=>up("brand",e.target.value)} style={{fontSize:12}}/></div>
        <div><label style={{fontFamily:"'DM Mono',monospace",fontSize:9,color:"var(--ink3)",display:"block",marginBottom:4}}>MODEL</label><input value={form.model} onChange={e=>up("model",e.target.value)} style={{fontSize:12}}/></div>
        <div><label style={{fontFamily:"'DM Mono',monospace",fontSize:9,color:"var(--ink3)",display:"block",marginBottom:4}}>DECADE</label><input value={form.decade} onChange={e=>up("decade",e.target.value)} style={{fontSize:12}} placeholder="e.g. 1970s"/></div>
        <div><label style={{fontFamily:"'DM Mono',monospace",fontSize:9,color:"var(--ink3)",display:"block",marginBottom:4}}>REFERENCE</label><input value={form.reference} onChange={e=>up("reference",e.target.value)} style={{fontSize:12}}/></div>
        <div><label style={{fontFamily:"'DM Mono',monospace",fontSize:9,color:"var(--ink3)",display:"block",marginBottom:4}}>CONDITION</label>
          <select value={form.condition} onChange={e=>up("condition",e.target.value)} style={{fontSize:12}}>
            <option value="">—</option>
            {["Mint","Excellent","Good","Fair","Poor"].map(c=><option key={c}>{c}</option>)}
          </select>
        </div>
        <div><label style={{fontFamily:"'DM Mono',monospace",fontSize:9,color:"var(--ink3)",display:"block",marginBottom:4}}>MOVEMENT</label>
          <select value={form.movement} onChange={e=>up("movement",e.target.value)} style={{fontSize:12}}>
            <option value="">—</option>
            {["Hand-wound","Automatic","Quartz"].map(m=><option key={m}>{m}</option>)}
          </select>
        </div>
        <div style={{gridColumn:"1/-1"}}><label style={{fontFamily:"'DM Mono',monospace",fontSize:9,color:"var(--ink3)",display:"block",marginBottom:4}}>PRICE (₹)</label><input value={form.price} onChange={e=>up("price",e.target.value)} type="number" style={{fontSize:12}}/></div>
      </div>
      <div style={{marginBottom:12}}>
        <label style={{fontFamily:"'DM Mono',monospace",fontSize:9,color:"var(--ink3)",display:"block",marginBottom:4}}>DESCRIPTION</label>
        <textarea value={form.description} onChange={e=>up("description",e.target.value)} rows={3} style={{fontSize:12,resize:"vertical"}}/>
      </div>
      <div style={{display:"flex",gap:8}}>
        <button className="btn-ink" onClick={save} style={{flex:1,padding:"9px 0",fontSize:12}}>Save changes</button>
        <button className="btn-ghost" onClick={()=>setOpen(false)} style={{padding:"9px 14px",fontSize:12}}>Cancel</button>
      </div>
    </div>
  );
}

// ─── Catalog Browse ───────────────────────────────────────────────────────────
